module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-500-[57]300.9f84f5f.woff2";